<!-- 设备列表 国标弹窗组件 -->
<template>
  <div>
    <el-dialog
      :title="editProperty ? $t('addDeviceConfig') : $t('editDeviceConfig')"
      :visible.sync="newDeviceConfig"
      :close-on-click-modal="false"
      :append-to-body="true"
      ref="editForm"
      width="90%"
      class="view-info common-blue-contain add-internet"
    >
      <el-form :model="newDeviceConfigForm" label-width="260px" label-position="right" ref="form">
        <div class="addPerson">
          <el-form-item :label="$t('sipServerAddress')" :required="true">
            <el-input
              v-model="newDeviceConfigForm.sipServerAddress"
              maxlength="128"
              autocomplete="off"
              clearable
              :placeholder="$t('psipServerAddress')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('sipServerPort')" :required="true">
            <el-input
              v-model="newDeviceConfigForm.sipServerPort"
              maxlength="10"
              oninput="value=value.replace(/[^\d]/g,'')"
              autocomplete="off"
              clearable
              :placeholder="$t('psipServerPort')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('sipServerId')" :required="true">
            <el-input
              v-model="newDeviceConfigForm.sipServerId"
              maxlength="128"
              autocomplete="off"
              clearable
              :placeholder="$t('psipServerId')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('sipServerDomain')">
            <el-input
              v-model="newDeviceConfigForm.sipServerDomain"
              maxlength="128"
              autocomplete="off"
              clearable
              :placeholder="$t('psipServerDomain')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('sipUser')" :required="true">
            <el-input
              v-model="newDeviceConfigForm.sipUser"
              maxlength="128"
              autocomplete="off"
              clearable
              :placeholder="$t('psipUser')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('sipAccount')" :required="true">
            <el-input
              v-model="newDeviceConfigForm.sipAccount"
              maxlength="128"
              autocomplete="off"
              :placeholder="$t('psipAccount')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('sipPwd')" :required="true">
            <el-input
              v-model="newDeviceConfigForm.sipPwd"
              maxlength="128"
              autocomplete="off"
              :placeholder="$t('psipPwd')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('sipLocalPort')">
            <el-input
              v-model="newDeviceConfigForm.sipLocalPort"
              maxlength="10"
              oninput="value=value.replace(/[^\d]/g,'')"
              autocomplete="off"
              :placeholder="$t('psipLocalPort')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('transportProtocol')">
            <el-input
              v-model="newDeviceConfigForm.transportProtocol"
              maxlength="10"
              autocomplete="off"
              :placeholder="$t('ptransportProtocol')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('validity')">
            <el-input
              v-model="newDeviceConfigForm.validity"
              maxlength="9"
              oninput="value=value.replace(/[^\d]/g,'')"
              autocomplete="off"
              :placeholder="$t('pvalidity')"
              clearable
            >
              <i slot="suffix" style="margin-right: 10px;">S</i>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('cardiacCycle')">
            <el-input
              v-model="newDeviceConfigForm.cardiacCycle"
              maxlength="9"
              oninput="value=value.replace(/[^\d]/g,'')"
              autocomplete="off"
              :placeholder="$t('pcardiacCycle')"
              clearable
            >
              <i slot="suffix" style="margin-right: 10px;">S</i>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('maxCardiacTime')">
            <el-input
              v-model="newDeviceConfigForm.maxCardiacTime"
              maxlength="9"
              oninput="value=value.replace(/[^\d]/g,'')"
              autocomplete="off"
              :placeholder="$t('pmaxCardiacTime')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('videoChannel')">
            <el-input
              v-model="newDeviceConfigForm.videoChannel"
              maxlength="128"
              autocomplete="off"
              :placeholder="$t('pvideoChannel')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('voiceChannel')">
            <el-input
              v-model="newDeviceConfigForm.voiceChannel"
              maxlength="128"
              autocomplete="off"
              :placeholder="$t('pvoiceChannel')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('amc')">
            <el-select
              v-model="newDeviceConfigForm.amc"
              maxlength="10"
              oninput="value=value.replace(/[^\d]/g,'')"
              :placeholder="$t('pamc')"
              clearable
              :popper-append-to-body='false'
            >
              <el-option :label="$t('softm')" :value="0"></el-option>
              <el-option :label="$t('hardm')" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('videoCoding')">
            <el-select
              v-model="newDeviceConfigForm.videoCoding"
              maxlength="10"
              oninput="value=value.replace(/[^\d]/g,'')"
              :placeholder="$t('pvideoCoding')"
              clearable
              :popper-append-to-body='false'
            >
              <el-option label="264" :value="264"></el-option>
              <el-option label="265" :value="265"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('resolutionRatio')">
            <el-select
              v-model="newDeviceConfigForm.resolutionRatio"
              maxlength="10"
              oninput="value=value.replace(/[^\d]/g,'')"
              :placeholder="$t('presolutionRatio')"
              clearable
              :popper-append-to-body='false'
            >
              <el-option label="480P" :value="480"></el-option>
              <el-option label="720P" :value="720"></el-option>
              <el-option label="1080P" :value="1080"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('codeRate')">
            <el-input
              v-model="newDeviceConfigForm.codeRate"
              maxlength="10"
              oninput="value=value.replace(/[^\d]/g,'')"
              :placeholder="$t('pcodeRate')"
              clearable
            >
              <i slot="suffix" style="margin-right: 10px;">KBPS</i>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('rateControl')">
            <el-select
              v-model="newDeviceConfigForm.rateControl"
              autocomplete="off"
              :placeholder="$t('prateControl')"
              clearable
              :popper-append-to-body='false'
            >
              <el-option :label="$t('不控制码率')" value="CQ"></el-option>
              <el-option :label="$t('固定码率')" value="CBR"></el-option>
              <el-option :label="$t('动态码率')" value="VBR"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('fps')">
            <el-select
              v-model="newDeviceConfigForm.fps"
              maxlength="10"
              oninput="value=value.replace(/[^\d]/g,'')"
              :placeholder="$t('pfps')"
              clearable
              :popper-append-to-body='false'
            >
              <el-option label="15FPS" :value="15"></el-option>
              <el-option label="20FPS" :value="20"></el-option>
              <el-option label="25FPS" :value="25"></el-option>
              <el-option label="30FPS" :value="30"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('profile')">
            <el-select v-model="newDeviceConfigForm.profile" autocomplete="off" :placeholder="$t('pprofile')" clearable :popper-append-to-body='false'>
              <el-option :label="$t('基线类')" value="Baseline"></el-option>
              <el-option :label="$t('主要类')" value="Main"></el-option>
              <el-option :label="$t('高端类')" value="HighProfile"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('plugFlow')">
            <el-select
              v-model="newDeviceConfigForm.plugFlow"
              maxlength="10"
              oninput="value=value.replace(/[^\d]/g,'')"
              :placeholder="$t('pplugFlow')"
              clearable
              :popper-append-to-body='false'
            >
              <el-option :label="$t('推送音视频')" :value="0"></el-option>
              <el-option :label="$t('仅推送视频')" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('deviceName')">
            <el-input
              v-model="newDeviceConfigForm.deviceName"
              maxlength="128"
              autocomplete="off"
              :placeholder="$t('pdeviceName')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('deviceManufacturer')">
            <el-input
              v-model="newDeviceConfigForm.deviceManufacturer"
              maxlength="128"
              autocomplete="off"
              :placeholder="$t('pdeviceManufacturer')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('watermark')">
            <el-select v-model="newDeviceConfigForm.watermark" :placeholder="$t('pwatermark')" clearable :popper-append-to-body='false'>
              <el-option :label="$t('关闭')" value="0"></el-option>
              <el-option :label="$t('开启')" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('watermarkFontSize')">
            <el-input
              v-model="newDeviceConfigForm.watermarkFontSize"
              maxlength="128"
              autocomplete="off"
              :placeholder="$t('pwatermarkFontSize')"
              clearable
            >
              <i slot="suffix" style="margin-right: 10px;">PX</i>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('watermarkFontHeight')">
            <el-input
              v-model="newDeviceConfigForm.watermarkFontHeight"
              maxlength="128"
              autocomplete="off"
              :placeholder="$t('pwatermarkFontHeight')"
              clearable
            >
              <i slot="suffix" style="margin-right: 10px;">PX</i>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('watermarkFontWidth')">
            <el-input
              v-model="newDeviceConfigForm.watermarkFontWidth"
              maxlength="128"
              autocomplete="off"
              :placeholder="$t('pwatermarkFontWidth')"
              clearable
            >
              <i slot="suffix" style="margin-right: 10px;">PX</i>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('extraData')">
            <el-input
              v-model="newDeviceConfigForm.extraData"
              autocomplete="off"
              :placeholder="$t('pextraData')"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDevice(editProperty)">{{ $t('determine') }}</el-button>
        <el-button @click="newDeviceConfig = false">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { errorMessage } from '@/util/common'
import { errorCollection } from '@/api/dmp/dmpCollection'
import { selectDevice, saveDevice, updateDevice } from '@/api/new-device/deviceGb'
export default {
  props: {},
  data() {
    return {
      editProperty: false,
      newDeviceConfig: false,
      //国标表单参数
      newDeviceConfigForm: {},
      newDevice: {
        id: '',
        sipServerAddress: '',
        sipServerPort: '',
        sipServerId: '',
        sipServerDomain: '',
        sipUser: '',
        sipAccount: '',
        sipPwd: '',
        sipLocalPort: 5060,
        transportProtocol: 'TCP',
        validity: 3600,
        cardiacCycle: 30,
        maxCardiacTime: 3,
        videoChannel: '34020000001320000001',
        voiceChannel: '34020000001370000001',
        amc: 0,
        videoCoding: 264,
        resolutionRatio: 720,
        codeRate: 1572864,
        rateControl: 'CBR',
        fps: 15,
        profile: 'Baseline',
        plugFlow: 0,
        deviceName: '',
        deviceManufacturer: '',
        watermark: '1',
        watermarkFontSize: '18',
        watermarkFontHeight: '15',
        watermarkFontWidth: '14',
        extraData: '',
      },
    }
  },
  methods: {
    //国标参数
    handleClick(row) {
      if (this.$refs.editForm) {
        // this.$refs.editForm.resetFields()
      }
      console.log(row, '新增 false：编辑')
      // 获取编辑时的国标参数
      selectDevice(row.id).then(res => {
        if (res.state === 0) {
          this.editProperty = false
          if (res.data === undefined) {
            this.editProperty = true // 区别弹窗 true：新增 false：编辑
          }
          this.newDeviceConfig = true
          this.newDeviceConfigForm = { ...this.newDevice, ...res.data, id: row.id }
        }
      })
    },
    // 提交添加
    submitDevice(type) {
      // 判断表单是否填入内容 提示
      if (this.newDeviceConfigForm.sipServerAddress === '') {
        errorCollection('设备国标参数', '新增设备国标参数', {
          status: 200,
          data: { state: -1, msg: '请输入SIP服务器地址' },
        })
        errorMessage(this.$t('psipServerAddress'))
        return
      } else if (this.newDeviceConfigForm.sipServerPort === '') {
        errorCollection('设备国标参数', '新增设备国标参数', {
          status: 200,
          data: { state: -1, msg: '请输入SIP服务器端口' },
        })
        errorMessage(this.$t('psipServerPort'))
        return
      } else if (this.newDeviceConfigForm.sipServerId === '') {
        errorCollection('设备国标参数', '新增设备国标参数', {
          status: 200,
          data: { state: -1, msg: '请输入SIP服务器ID' },
        })
        errorMessage(this.$t('psipServerId'))
        return
      } else if (this.newDeviceConfigForm.sipUser === '') {
        errorCollection('设备国标参数', '新增设备国标参数', {
          status: 200,
          data: { state: -1, msg: '请输入SIP用户名' },
        })
        errorMessage(this.$t('psipUser'))
        return
      } else if (this.newDeviceConfigForm.sipAccount === '') {
        errorCollection('设备国标参数', '新增设备国标参数', {
          status: 200,
          data: { state: -1, msg: '请输入SIP用户认证ID' },
        })
        errorMessage(this.$t('psipAccount'))
        return
      } else if (this.newDeviceConfigForm.sipPwd === '') {
        errorCollection('设备国标参数', '新增设备国标参数', {
          status: 200,
          data: { state: -1, msg: '请输入SIP用户认证密码' },
        })
        errorMessage(this.$t('psipPwd'))
        return
      } else {
        if (type === true) {
          // type 为true时：添加；false：编辑
          saveDevice(this.newDeviceConfigForm).then(res => {
            if (res.state === 0) {
              this.$message({ type: 'success', message: '新增成功!' })
              this.newDeviceConfig = false
            }
          })
        } else {
          updateDevice(this.newDeviceConfigForm).then(res => {
            if (res.state === 0) {
              this.$message({ type: 'success', message: '编辑成功!' })
              this.newDeviceConfig = false
            }
          })
        }
      }
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
>>>.el-popper
  min-width 200px!important
</style>
